// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"jb","modalBox":"jb","modal-mask":"jc","modalMask":"jc","close-btn":"jd","closeBtn":"jd","container":"je","content":"jf","title":"jg","subTitle":"jh","detail":"ji"};